import React from 'react';
import { ISocialButtons } from './interfaces';
import { Chip, Stack } from '@mui/material';
import ThumbUpAltIcon from '@mui/icons-material/ThumbUpAlt';
import ThumbUpOffAltIcon from '@mui/icons-material/ThumbUpOffAlt';
import ChatIcon from '@mui/icons-material/Chat';
import { useTranslation } from 'react-i18next';

export const SocialButtons: React.FC<ISocialButtons> = ({
  numberOfLikes,
  numberOfComments,
  liked = false,
  onLikeClick,
  sx,
}): JSX.Element => {
  const { t } = useTranslation();

  return (
    <Stack direction="row" columnGap="5px" sx={sx}>
      {numberOfLikes !== undefined && (
        <Chip
          icon={liked ? <ThumbUpAltIcon /> : <ThumbUpOffAltIcon />}
          label={
            numberOfLikes > 0
              ? `${numberOfLikes} ${t('feed:buttons.likes', {
                  count: numberOfLikes,
                })}`
              : t('feed:buttons.likes', { count: 1 })
          }
          color={liked ? 'primary' : 'light'}
          size="small"
          onClick={onLikeClick}
        />
      )}
      {numberOfComments !== undefined && numberOfComments !== null && (
        <Chip
          icon={<ChatIcon />}
          label={`${numberOfComments} ${t('feed:buttons.reactions', {
            count: numberOfComments,
          }).toLocaleLowerCase()}`}
          size="small"
          color="light"
        />
      )}
    </Stack>
  );
};
